import { connect } from 'react-redux';
import {
  fetchInventoryTags,
  deleteInventoryTag
} from '../../../redux/Inventory/sagas/tag/routines';
import {
  getIsFetching,
  getIsFetched,
  getIsDeleting,
  getIsDeleted,
  getOrder
} from '../../../redux/Inventory/selectors/tag';
import {
  clearIventoryTags,
  inventoryTagsOnChangePage,
  inventoryTagsOnChangeOrder
} from '../../../redux/Inventory/actions/tag';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageTags
} from '../../../redux/Inventory/selectors/tag/pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import InventoryTagList from '../../../components/inventory/TagList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.TAG);
  const order = getOrder(state);
  return {
    tags: orderList(order, getCurrentPageTags(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isFetched: getIsFetched(state),
    isDeleting: getIsDeleting(state),
    isDeleted: getIsDeleted(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryTags());
    },
    onDelete: tag => {
      dispatch(deleteInventoryTag(tag));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryTags(query));
      else dispatch(inventoryTagsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearIventoryTags());
      dispatch(fetchInventoryTags(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearIventoryTags());
      dispatch(fetchInventoryTags({ ...query, order }));
      dispatch(inventoryTagsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryTagList);
